var e={openDescriptionBtnText:"See more",moreDescriptionLinkText:"Read more",lessDescriptionLinkText:"See less"};export{e as recommendedProductTranslations};
